export const blockIconsSearchDining = (
	<span className='material-symbols-outlined'>dining</span>
);
